import { useTranslation } from 'react-i18next';
import { Stack } from '@koob/margaret';
import { formatCurrency } from 'utils';
import { formatDateTime, DATE_TIME_TZ } from '@koob/dates';
import RateTag from './RateTag';

const ExperienceDynamicCancelConditions = ({
  currency,
  translationKey,
  cancelConditions,
}) => {
  const { t } = useTranslation(translationKey);

  if (!cancelConditions || cancelConditions.length === 0) {
    return null;
  }

  const isRefundable = cancelConditions?.some((p) => p.refundable);

  return (
    <div className="py-4">
      <Stack gutterSize={0.5}>
        <RateTag
          color={isRefundable ? 'green' : 'red'}
          label={t(
            isRefundable
              ? `${translationKey}:refundable_tag:room_refundable`
              : `${translationKey}:refundable_tag:room_non_refundable`,
          )}
        />
      </Stack>
      <Stack direction="column" gutterSize={1}>
        {cancelConditions?.map((policy, index) => (
          <p key={index} className="mt-2.5">
            {`"${formatDateTime(policy.startAt, DATE_TIME_TZ)}"`}{' '}
            {t('bookings:to')}{' '}
            {`"${formatDateTime(policy?.endAt, DATE_TIME_TZ)}"`}
            {', '}
            {t(`${translationKey}:cancellationFees`)} {'= '}
            {formatCurrency({
              amount: policy.deduction,
              currency,
            })}
          </p>
        ))}
      </Stack>
    </div>
  );
};

export default ExperienceDynamicCancelConditions;
